import {
  apiCreateCupsRef,
  apiDeleteUseFromCups,
  apiPatchUseFromCups,
  apiPostUseFromCups,
  getCUPSwithMetersAndUses
} from '../../api/Argentia/endpoints/contracts/contracts.api'
import { apiGetLogisticElements } from '../../api/Argentia/endpoints/logisticElements/logisticElements.api'
import { LogisticElementFilterModel } from '../../api/Argentia/endpoints/logisticElements/model/logisticElements'
import { CUPSModel, LogisticElementModel, UseModel } from '../../api/Argentia/model/contracts'
import {
  createErrorServiceResponse,
  createSuccessServiceResponse
} from '../../helpers/serviceResponseHelper'
import { ServiceResponse } from '../../model/serviceResponse'
import { UseModelPatch } from '../uses/uses.model'

export const fetchCUPSwithMetersAndUses = async (
  CUPSCode: string
): Promise<ServiceResponse<CUPSModel[] | undefined>> => {
  return getCUPSwithMetersAndUses(CUPSCode)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchLogisticElements = async (
  filter: LogisticElementFilterModel
): Promise<ServiceResponse<LogisticElementModel[] | undefined>> => {
  return apiGetLogisticElements(filter)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const createCupsRef = async (
  cupsID: number,
  navigationProperty: 'distribuidora' | 'elementoLogistico',
  keyID: number
): Promise<ServiceResponse<any>> => {
  return apiCreateCupsRef(cupsID, navigationProperty, keyID)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const createUseFromCups = async (
  newUse: UseModel,
  cupsID: number
): Promise<ServiceResponse<UseModel | undefined>> => {
  return apiPostUseFromCups(newUse, cupsID)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const deleteUseFromCups = async (
  useID: number,
  cupsID: number
): Promise<ServiceResponse<any>> => {
  return apiDeleteUseFromCups(useID, cupsID)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const updateUseFromCups = async (
  use: UseModelPatch,
  cupsID: number
): Promise<ServiceResponse<UseModel | undefined>> => {
  return apiPatchUseFromCups(use, cupsID)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}
